import { render, staticRenderFns } from "./ModalNewNotification.vue?vue&type=template&id=66e2c012&scoped=true"
import script from "./ModalNewNotification.vue?vue&type=script&lang=js"
export * from "./ModalNewNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e2c012",
  null
  
)

export default component.exports